export default __webpack_public_path__ + "static/media/640_business01-jp-mobile.425d4a45.png";